import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-stone-500 font-mono-code text-sm">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
}
